export default {
    prefix: "mp", // use to prefix localStorage keys, cookies etc.
    defaultLanguage: "en",
    buildId: import.meta.env.VITE_BUILD,
    clientRoot: window.location.origin,
    apiRoot: import.meta.env.NODE_ENV === "test" ? "http://localhost" : import.meta.env.VITE_API_ROOT,
    appInsightsKey: import.meta.env.VITE_APPINSIGHTS_KEY,
    requestAccessURI: import.meta.env.VITE_REQUEST_ACCESS_URI,
    registerCompanyURI: import.meta.env.VITE_REGISTER_COMPANY_URI,
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    lisExchangeWebServiceRecipients: import.meta.env.VITE_LIS_EXCHANGE_WEB_SERVICE_RECIPIENTS,
    lisConfluenceReleasesPageUri: import.meta.env.VITE_LIS_CONFLUENCE_RELEASES_PAGE_URL,
    lisConfluenceKeyUsersPageUri: import.meta.env.VITE_LIS_CONFLUENCE_KEY_USERS_PAGE_URL,
    lisConfluenceResolveCRConflictsPageUri: import.meta.env.VITE_LIS_CONFLUENCE_RESOLVE_CR_CONFLICTS_PAGE_URL,
    environmentSuffix: import.meta.env.VITE_APP_STORE_BUNDLE_ID_SUFFIX,
    auth: {
        server: import.meta.env.VITE_AUTH_SERVER,
        clientId: import.meta.env.VITE_AUTH_CLIENT_ID,
        scope: import.meta.env.VITE_AUTH_SCOPE,
        redirectURI: import.meta.env.VITE_AUTH_REDIRECT_URI,
        silentRenewURI: import.meta.env.VITE_AUTH_SILENT_RENEW_URI,
    }
}
